/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PricesInputs */

const en_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices`)
};

const es_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const de_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const zh_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const ar_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار`)
};

const fr_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs`)
};

const vi_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const sw_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei`)
};

const th_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const bs_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene`)
};

const ja_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金`)
};

const ko_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금`)
};

const pt_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços`)
};

const it_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

const sv_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const nl_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen`)
};

const da_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const nb_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const fi_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat`)
};

const pl_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik`)
};

const ru_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены`)
};

const tr_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlar`)
};

const hi_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमतें`)
};

const id_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const cs_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny`)
};

const el_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές`)
};

const he_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירים`)
};

const af_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse`)
};

const hu_nav_prices = /** @type {(inputs: Nav_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árak`)
};

/**
* | output |
* | --- |
* | "Prices" |
*
* @param {Nav_PricesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_prices = /** @type {((inputs?: Nav_PricesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PricesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_prices(inputs)
	if (locale === "de") return de_nav_prices(inputs)
	if (locale === "zh") return zh_nav_prices(inputs)
	if (locale === "ar") return ar_nav_prices(inputs)
	if (locale === "fr") return fr_nav_prices(inputs)
	if (locale === "vi") return vi_nav_prices(inputs)
	if (locale === "sw") return sw_nav_prices(inputs)
	if (locale === "th") return th_nav_prices(inputs)
	if (locale === "bs") return bs_nav_prices(inputs)
	if (locale === "ja") return ja_nav_prices(inputs)
	if (locale === "ko") return ko_nav_prices(inputs)
	if (locale === "pt") return pt_nav_prices(inputs)
	if (locale === "it") return it_nav_prices(inputs)
	if (locale === "sv") return sv_nav_prices(inputs)
	if (locale === "nl") return nl_nav_prices(inputs)
	if (locale === "da") return da_nav_prices(inputs)
	if (locale === "nb") return nb_nav_prices(inputs)
	if (locale === "fi") return fi_nav_prices(inputs)
	if (locale === "pl") return pl_nav_prices(inputs)
	if (locale === "ru") return ru_nav_prices(inputs)
	if (locale === "tr") return tr_nav_prices(inputs)
	if (locale === "hi") return hi_nav_prices(inputs)
	if (locale === "id") return id_nav_prices(inputs)
	if (locale === "ms") return ms_nav_prices(inputs)
	if (locale === "cs") return cs_nav_prices(inputs)
	if (locale === "el") return el_nav_prices(inputs)
	if (locale === "he") return he_nav_prices(inputs)
	if (locale === "af") return af_nav_prices(inputs)
	if (locale === "hu") return hu_nav_prices(inputs)
	return en_nav_prices(inputs)
});